import { useMutatePrivate, useQueryPrivate } from "../hooks/useFetchPrivate";
import { fetchBase } from "./fetchBase";

export const useGetCurrentUserApi = (
  { useQueryOptions } = { useQueryOptions: undefined },
) => {
  return useQueryPrivate({ url: "user" }, useQueryOptions);
};

export const getCurrentUserApi = (axios) => {
  return fetchBase({ url: "user" }, axios);
};

export const useUpdateUserInfoApi = ({ useMutateOptions } = {}) => {
  const { mutate, ...rest } = useMutatePrivate(
    { method: "put", url: "user" },
    useMutateOptions,
  );
  return {
    mutate: (data) => mutate({ data }),
    ...rest,
  };
};
